module.exports = __webpack_public_path__ + "img/rule_diamonds.febfd16b.png";